export default __webpack_public_path__ + "static/media/laughing_girl.09937b85.mp4";